<div class="fixed inset-0 z-40 bg-modalBg" (click)="onClose()"></div>

<div
  #modalContainer
  tabindex="-1"
  class="fixed z-50 flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 min-h-[200px] flex-grow flex-col justify-between p-card-padding-phone for-laptop-up:p-container-space-laptop bg-white h-auto w-full for-laptop-up:w-auto for-laptop-up:min-w-[400px] rounded-xl"
  *transloco="let t; scope: 'modalConfirm'; read: 'modalConfirm'"
>
  <div class="flex justify-between">
    <h1 class="text-lg font-semibold for-laptop-up:text-h3 text-primary">
      {{ title }}
    </h1>
    <button (click)="onClose()" type="button">
      <img
        class="hover:cursor-pointer"
        src="../../../../assets/svg/exit-icon.svg"
        alt="close-icon"
      />
    </button>
  </div>

  <div class="flex flex-col flex-grow gap-2 pt-8 overflow-scroll text-md">
    <ng-content></ng-content>
  </div>
</div>
